import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, makeStyles, Tab, tokens } from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { fetchRelation } from "./relation-slice";
import { fetchVacancyUids } from "../vacancy/vacancies-uids-slice";
import { ENTITY_RELATION } from "../../utils/Constants";
import TabHeader from "../../blocks/tab/TabHeader";
import TabContent from "../../blocks/tab/TabContent";
import RelationInfo from "./RelationInfo";
import Notes from "../note/Notes";
import DocumentSelection from "../document/DocumentSelection";
import Vacancies from "../vacancy/Vacancies";
import PageHeader from "../../blocks/PageHeader";
import BottomFixedButton from "../../blocks/BottomFixedButton";

const RelationPage = () => {
  const { uid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [document, setDocument] = useState(null);
  const [selectedTab, setSelectedTab] = useState(location.state?.selectedTab || "general");
  const skipPageHeader = location.state?.skipPageHeader;

  const dispatch: AppDispatch = useDispatch();
  const { relation, loading } = useSelector((state: RootState) => state.relation);
  const { vacancyUids } = useSelector((state: RootState) => state.vacancyUids);

  useEffect(() => {
    if (uid) {
      dispatch(fetchRelation(uid));
      dispatch(fetchVacancyUids({ uid, entity: ENTITY_RELATION }));
    }
  }, [dispatch, uid]);

  const handleDocReady = (document) => {
    if (document) {
      setDocument(document);
      setSelectedTab("upload");
    }
  };

  const handleDocDetails = () => {
    navigate("/document-details", {
      state: { uid, entity: ENTITY_RELATION, document, skipPageHeader, selectedTab },
    });
  };

  const handleNoteForm = () => {
    navigate("/note-form", {
      state: { uid, entity: ENTITY_RELATION, skipPageHeader, selectedTab },
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      {!skipPageHeader && <PageHeader onBack={handleBack} />}
        
      {!loading && relation && (
        <>
          <TabHeader
            name={relation?.relation || ""}
            status={relation?.status?.name}
            profileImage={relation?.profileImage}
            entity={ENTITY_RELATION}
            entityId={relation?.uid}
          />
          <TabContent selectedTab={selectedTab} skipPageHeader={skipPageHeader} onTabChange={setSelectedTab}>
            <Tab value="general" name="General">
              <RelationInfo relation={relation} />
            </Tab>
            <Tab value="vacancies" name="Vacancies">
              <Vacancies uids={vacancyUids} />
            </Tab>
            <Tab value="notes" name="Notes">
              <>
                <Notes entity={ENTITY_RELATION} uid={relation?.uid} />
                <BottomFixedButton appearance="primary" onClick={handleNoteForm} buttonText="New note" />
              </>
            </Tab>
            <Tab value="upload" name="Upload Documents">
              <>
                <DocumentSelection onReady={handleDocReady} />
                <BottomFixedButton
                  appearance="primary"
                  onClick={handleDocDetails}
                  disabled={!document}
                  buttonText="Next" />
              </>
            </Tab>
          </TabContent>
        </>
      )}
    </>
  );
};

export default RelationPage;
